module.exports = {"140924100":"繁城镇","140924101":"砂河镇","140924102":"大营镇","140924103":"平型关镇","140924200":"下茹越乡","140924202":"光裕堡乡","140924203":"集义庄乡","140924204":"东山乡","140924205":"金山铺乡","140924208":"神堂堡乡","140924209":"岩头乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140924.json
// module id = 438
// module chunks = 0